import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  navigate: ["routeName", "params"],
  goBack: null,
});

export const NavigationTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  currentRoute: 'home',
  params: null,
});

export const NavigationSelectors = {
  getCurrentRoute: (state: any) => state.nav.currentRoute,
  getParams: (state: any) => state.nav.params,
};

export const navigate = (state: any, action: any) => {
  const { routeName, params } = action;
    const updateData = {
    currentRoute: routeName,
    params,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const goBack = (state: any) => state.merge({});

export const reducer = createReducer(INITIAL_STATE, {
  [Types.NAVIGATE]: navigate,
  [Types.GO_BACK]: goBack,
});
